import React from 'react';
import './Chevron.scss';

const Chevron = ({
    direction,
    isFilled,
}: {
    direction: string;
    isFilled?: boolean;
}) => (
    <div className="chevron-icon-container">
        <div className={`chevron-${direction}`}>
            {isFilled ? (
                <span className="fds-icon">
                    <span className="fds-font--ford-icons__chevron-filled-right-path1"></span>
                    <span className="fds-font--ford-icons__chevron-filled-right-path2"></span>
                </span>
            ) : (
                <svg
                    width="11"
                    height="21"
                    viewBox="0 0 11 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#0276B3"
                >
                    <rect transform="rotate(90)" />
                    <path
                        d="M0.999878 11L10.0922 20.0919"
                        strokeLinecap="square"
                    />
                    <path d="M10.0918 1.70715L1 11" strokeLinecap="square" />
                </svg>
            )}
        </div>
    </div>
);

export default Chevron;
